export class CustomerUserAgent {
    public customerUserAgentId: number;
    public userId: number;
    public customerNumberId: number;
    public customerName: string;
    public isDelete: boolean;
    public dateOfBirth: Date;
    public ssnLast4: string;
    public customerIdentificationTypeId: number;
    public customerIdentificationValue: string;
}
